
import React from "react";
import Überschrift from "./überschrift";
import Loinport from "./loinport";




class Mainlogin extends React.Component{
   render() {
        return (
            <React.Fragment>
                <Überschrift/>
                <Loinport/>
            </React.Fragment>
            
        )
    }

}

export default Mainlogin;